import { PageHeader } from "@/pages/layoutChrome";
import ChatInternoEquipoPanel from "@/components/equipo/ChatInternoEquipoPanel";

/**
 * Página dedicada del chat interno — deep link /equipo/chat (misma UI embebida en Panel General).
 */
export default function ChatInternoGeneral() {
  return (
    <div className="p-8 max-w-4xl space-y-5" data-testid="chat-interno-general-page">
      <PageHeader
        title="Chat interno del equipo"
        subtitle="Comunicación general entre usuarios activos de tu organización."
      />
      <ChatInternoEquipoPanel />
    </div>
  );
}
